import React, { useState } from 'react'
import { Wrapper, BarStrip, ProgressBar, ModalComponent,TextAreaIcon, SelectFieldIcon } from '../_components'
import Table, { SelectColumnFilter } from '../_components/Table'
import data from '../fixtures'
import Axios from 'axios'
import moment from 'moment'
import { useSelector, useDispatch } from 'react-redux'
import { setPaymentModal } from '../_slices/AppSlice'
import { Formik } from 'formik'
import { CircularProgress } from '@material-ui/core'

const ActionField = ( record ) => {
    return (
      ( record.row.original?.prn_status !== null && localStorage.getItem( "role" ) === "APPLICANT" ) && 
        ( <div onClick={async () => {
            //add check if payment_reference_number is expired and action below 
            let application_id = record.row.original.id
            try {
              const response = await Axios.get( process.env.REACT_APP_API_URL+`/api/auth/re_generate_payment_slip_for_client/${application_id}` )
              if( response.data ){
                //setCircularLoading(true)
                alert(response.data.message)
                await localStorage.setItem( "link", "payments" )
                return window.location.reload()
              }
            } catch (error) {}
          }} className="cursor-pointer w-auto md:w-20 lg:w-24 py-1 px-2 rounded bg-[#3669c8] text-xs text-white flex items-center justify-center">
        {`Payment Slip`}
      </div> )
    )
}

const BankPaymentActionField = ( record ) => {
  return (
    ( record.row.original?.payment_reference_number !== null && localStorage.getItem( "role" ) === "APPLICANT" ) && 
      ( <div onClick={async () => {
          //add check if payment_reference_number is expired and action below 
          let application_id = record.row.original.id
          try {
            await localStorage.setItem( "applicationId", application_id )
            await localStorage.setItem( "link", "gt_bank_payment" )
            return window.location.reload()
          } catch (error) {}
        }} className="cursor-pointer w-auto md:w-20 lg:w-24 py-1 px-2 rounded bg-[#AFC836] text-xs text-black flex items-center justify-center">
      {`Make Payment`}
    </div> )
  )
}

const PrintInvoiceActionField = ( record ) => {
  const dispatch = useDispatch()

  return (
    ( parseInt( record.row.original?.stage ) === 1 && localStorage.getItem( "role" ) === "APPLICANT" ) && 
      ( <a onClick={async () => {
      let db_record_details = record.row.original

      try {
        const response = await Axios.post( process.env.REACT_APP_API_URL+`/api/auth/generate_application_ura_prn`, {
          trading_name: db_record_details.applicant,
          email: db_record_details.email_address,
        })
        if( response.data ) {
          if (response.data.message === "success") {
            const application_id = response.data.application_id

            //send application details for printing invoice
            const url = process.env.REACT_APP_API_URL+`/api/auth/ura_payment_invoice/`+application_id+`/print`
            const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
            if (newWindow) newWindow.opener = null
          } else {
            console.log(response.data)
            alert("Application details not found. Contact the NITA-U Certification Office")
          }
        }
      } catch (error) {
        console.log("error==")
        console.log(error)
      }
    } } className="cursor-pointer w-auto md:w-20 lg:w-24 py-1 px-2 rounded bg-[#AFC836] text-xs text-black flex items-center justify-center">
      {`Make Payment`}
    </a> )
  )
}

const ProgressField = record => {
    return (
      <div className="flex w-full items-center justify-center">
        <ProgressBar value={record.value}/>
        <div className="text-xs mx-2">
            {`${record.value}%`}
        </div>
      </div>
    )
}

// const ActionField = record => {
//   // const dispatch = useDispatch()

//   const handleClick = async id => {
//     await localStorage.setItem( "applicationId", id )
//     await localStorage.setItem( "link", "display")
//     window.location.reload()
//   }

//   return (
//     record.row.original.verify_status?.toLowerCase() !== "completed" && 
//     (<div onClick={() => handleClick( record.value )} className="uppercase cursor-pointer bg-green-700 text-xs text-center px-2 py-1 rounded text-white">
//       {`Verify Documents`}
//     </div> )
//   )
// }

export default function MyPayments( { product } ) {
  const PaymentColumns = React.useMemo( () => [
    {
      Header: "#",
      accessor: "recordId"
    },
    {
      Header: "Serial Number",
      accessor: "sno"
    },
    {
      Header: "Registered Name of Applicant",
      accessor: "applicant"
    },
    {
      Header: "Email Address",
      accessor: "email_address"
    },
    {
      Header: "Annual Gross Income(UGX)",
      accessor: "annual_income"
    },
    {
        Header: "Action",
        accessor: "id",
        Cell: ActionField
    },
    {
      Header: "Action",
      accessor: "id_to_pay",
      Cell: BankPaymentActionField
    },
    /* {
      Header: "Action",
      accessor: "email",
      Cell: PrintInvoiceActionField
    } */
   
  ] )
  
  const [ records, setRecords ] = useState( [] )
  const [ loading, setLoading ] = useState( true )
  const [ circularLoading, setCircularLoading ] = useState( false )
  const dispatch = useDispatch()
  const state = useSelector( state => {
    return {
        paymentFlag: state.application.paymentModal?.paymentFlag,
        title: state.application.paymentModal?.title,
    }
  } )

  React.useEffect( () => {
    if( loading ) {
        fetchApplications()
    }
  },[ loading ])

  const fetchApplications = async () => {
    try {
      const response = await Axios.get( process.env.REACT_APP_API_URL+`/api/auth/fetch_expired_prn_apps` ) 
      if( response.data ) {
       const results = response.data.map( ( result, index ) => {
        return {
            recordId: `${index+1}`,
            sno: result.serial_number,
            progress: result.progress,
            stage: result.stage,
            applicant: result.trading_name,
            email_address: result.created_by,
            date: moment( result.created_at ).format( "DD MMM, YYYY" ),
            prn_status: result.prn_status,
            annual_income: result.annual_turnover,
            id: result.id,
            id_to_pay: result.id
        }
       } ).filter( record => (record.prn_status === null && record.email_address?.toLowerCase() === localStorage.getItem( "email" )?.toLowerCase()) )

       setRecords( results )
       setLoading( false )
      }
    } catch (error) {
      alert( "Server error occured." )
      setLoading( false )
    }
  }

  const handleClientPayment = async () => {
    const payload = JSON.parse( localStorage.getItem( "paymentPayload" ))
    try {
        const response = await Axios.post( process.env.REACT_APP_API_URL+`/api/auth/itcoverify`, {
          id: payload.id,
          progress: parseInt( payload.progress ) + 20,
          stage: parseInt( payload.stage ) + 1,
          role: localStorage.getItem( "role" ),
          comments: "Payment",
          actioned_by: localStorage.getItem( "username"),
          email_address: localStorage.getItem( "username")
        //   email_address: record.created_by,
        //   task: "Verified",
        //   created_by: localStorage.getItem( "email" ),
        //   comment: "This application is now Verified",
        //   verification_status: "Completed"
        } )
        if( response.data ) {
          dispatch( setPaymentModal( { paymentFlag: false, title: "" } ) )
          alert( response.data.message )
          // await dispatch( setDisplayVerify( { 
          //   flag: false
          // } ))
          return window.location.reload()
        }
    } catch (error) {}
  }

  return (
    <Wrapper>
        <div className="flex flex-col h-full">
          <BarStrip />
          <div className="flex-grow flex flex-col bg-gray-100 my-2 px-5">
            <div className="px-5 py-2 text-sm bg-white">
              {`My Payments`}
            </div>
            <div className="flex w-full bg-white">
              {loading ? ( <div className="flex items-center justify-center">{`Loading`}</div> )
              : ( <Table 
                label="Application Details"
                columns={PaymentColumns}
                data={records}
              /> ) }
            </div>
          </div>
        </div>
        <ModalComponent title={state.title} open={state.paymentFlag} handleOpen={() => dispatch( setPaymentModal( { paymentFlag: false, title: "" } ) )}>
          {/* <div className="cursor-pointer" >Close</div> */}
          <div className="grid grid-cols-1 w-[700px]">
            <div>
            <Formik initialValues={{
              action: "",
              actioned_by: localStorage.getItem( "username" ),
              comments: ""
              }} onSubmit={() =>{}}>
              { ( { handleSubmit, handleBlur, handleChange, values, isSubmitting } ) => {
                return (
                    <form className="w-full my-2 bg-white" onSubmit={handleSubmit}>

                        <div className="w-full grid grid-rows-2 gap-1">
                            <SelectFieldIcon 
                                name="action"
                                handleChange={handleChange}
                                handleBlur={handleBlur}
                                value={values.action}
                                label="Action"
                                required={true}
                                disabled={false}
                                options={[ 
                                    { id: 1, value: "MakePayment", label: "Make Payment" },
                                    // { id: 2, value: "Fail", label: "Fail" }
                                ]}
                                question="Next Course of Action" />

                            <TextAreaIcon
                              rows={3}
                              cols={5}
                              name="comments"
                              value={values.comments}
                              handleChange={handleChange}
                              handleBlur={handleBlur}
                              label="Comments"
                              disabled={false}
                              question={`Add any comments/remarks`}
                              required={false}
                            />
                        </div>
                    </form>
                  )
                }  }
            </Formik>
            </div>
            <div className="flex items-center">
              <button onClick={() => dispatch( setPaymentModal( { paymentFlag: false, title: "" } ) )} className="bg-blue-700 w-20 text-white text-xs my-2 px-2 py-1 mx-2" type="button">
                {`Cancel`}
              </button>
              <button onClick={handleClientPayment} className="bg-green-700 w-20 text-white text-xs my-2 px-2 py-1" type="button">
                {`Submit`}
              </button>
            </div>
          </div>
        </ModalComponent>
    </Wrapper>
  )
}
